<template>
  <div class="aia-container-box simhei_aia_font" :style="backgroundStyle">
    <div class="aia-title aia-title-distance">
      <div>欢迎来到</div>
      <div>Metacademy</div>
      <div class="aia-title-last">职业启航游元会</div>
      <img
        v-if="showTips"
        src="@/assets/images/login/aia-title-tips.png"
        alt="招募"
      />
    </div>
    <slot name="login"></slot>
    <login-footer :footerTitle="'虚拟空间技术支持: '" />
  </div>
</template>

<script>
import LoginFooter from '@/components/login/LoginFooter.vue'
import { getBusinessType } from '@/constant'

export default {
  components: { LoginFooter },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${getBusinessType().bg})`,
        minHeight: 'auto',
        backgroundSize: 'cover',
        backgroundRepeat: `${getBusinessType().bgRepeat || 'round'}`,
      }
    },
    showTips() {
      return this.$route.name === 'aia-hr'
    },
  },
}
</script>

<style lang="scss" scoped>
.simhei_aia_font {
  font-family: 'Simhei_Aia', sans-serif;
  .el-button {
    font-family: 'Simhei_Aia', sans-serif !important;
  }
  .el-input {
    font-family: 'Simhei_Aia', sans-serif !important;
  }
}
.aia-container-box {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  overflow-x: hidden;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  background-position: center;
  // fix: 处理点击页面出现阴影问题
  *,
  input,
  button {
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-appearance: none;
  }
  .aia-title {
    position: relative;
    width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    text-align: left;
    color: #3d4d68;
    opacity: 0.9;
  }
  .aia-title-last {
    font-size: 16px;
    line-height: 24px;
    color: rgba(68, 88, 123, 0.8);
  }
  .footer-box {
    position: absolute;
    bottom: 20px;
  }
}
@media all and (orientation: landscape) {
  // 横屏
  .aia-container-box {
    min-height: 100% !important;
    height: auto;
  }
}
@media all and (orientation: portrait) {
  // 竖屏
  .aia-container-box {
    height: 100%;
  }
}
.aia-button.el-button {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.aia-button-custom.el-button {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  background: linear-gradient(180deg, #e4708f -14.96%, #d31145 100%) !important;
  height: 50px;
}
.aia-title-distance {
  margin: 20vh 0 0 20vw;
  img {
    width: 150px;
    display: block;
    margin-top: 4px;
  }
}
</style>
